import { Fragment } from "react";
import { negativeResponse } from "../../../helpers";

export const PatientSurgeryEvaluationAccordion = ({ evaluations }) => {
  // console.log("evaluations", evaluations);
  const isNegativeYes = (question) =>
    question.value === "Sí" &&
    negativeResponse.some((item) => item.id === question.id);
  return (
    <div className="accordion" id="evaluationsPatient">
      {evaluations.map((evaluation, index) => (
        <div className="accordion-item" key={evaluation.questionGroupId}>
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${index === 0 ? "" : "collapsed"}`}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#question-group-${evaluation.questionGroupId}`}
              aria-expanded="true"
              aria-controls={`question-group-${evaluation.questionGroupId}`}
            >
              Encuesta: {evaluation.title}
            </button>
          </h2>
          <div
            id={`question-group-${evaluation.questionGroupId}`}
            className={`accordion-collapse collapse ${
              index === 0 ? "show" : ""
            }`}
            data-bs-parent="#evaluationsPatient"
          >
            <div className="accordion-body">
              <div className="table-responsive">
                <table className="table">
                  <thead className="table-primary">
                    <tr>
                      <th className="border-bottom p-3">#</th>
                      <th className="border-bottom p-3">Preguntas</th>
                      <th className="border-bottom p-3">Respuestas</th>
                    </tr>
                  </thead>
                  <tbody>
                    {evaluation.questions.map((question, index) => {
                      const numRows = question.followUpQuestion ? 2 : 1;
                      return (
                        <Fragment key={question.id}>
                          <tr>
                            <td className="py-3 fw-bold" rowSpan={numRows}>
                              {index + 1}.
                            </td>
                            <td
                              className={`py-3 ${
                                isNegativeYes(question) ? "text-underline-success" : ""
                              }`}
                            >
                              {question.title}
                            </td>
                            <td
                              className={`py-3 ${
                                isNegativeYes(question) ? "text-underline-success" : ""
                              }`}
                            >
                              {question.value}
                            </td>
                          </tr>
                          {question.followUpQuestion && (
                            <tr>
                              <td
                                className={`py-3 ${
                                  question.followUpQuestion.value === "Sí"
                                    ? "text-underline-success"
                                    : ""
                                }`}
                              >
                                {question.followUpQuestion.title}
                              </td>
                              <td className="py-3">
                                <div>{question.followUpQuestion.value}</div>
                                {question.followUpQuestion.files?.length >
                                  0 && (
                                  <div className="mt-2">
                                    {question.followUpQuestion.files.map(
                                      (file) => (
                                        <div key={file.id}>
                                          <a
                                            href={file.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            {file.originalName}
                                          </a>
                                        </div>
                                      )
                                    )}
                                  </div>
                                )}
                              </td>
                            </tr>
                          )}
                        </Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
